export default {
  data() {
    return {
      isModalActive: false
    }
  },
  methods: {
    toggleModal() {
      this.isModalActive = !this.isModalActive
    }
  }
}
